import React, { FC, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  StatusSection,
  StatusRow,
  StatusLabel,
  StatusValue,
  StatusIndicator,
} from './status-styles'
import { TopProgress } from '../../../components'
import { ukrsibService } from '../../../api'
import { useUi } from '../../../context/ui.context'
import { timeConverterMMDDYYHHMM } from '../../../utils/dates'

const StatusTab: FC = () => {
  const [t] = useTranslation()
  const { viewAlert } = useUi()
  const [status, setStatus] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const _updateStatus = () => {
    ukrsibService.getStatus()
      .then((res) => {
        setStatus(res.data)
        setLoading(false)
      })
      .catch((err) => {
        viewAlert({
          severity: 'error',
          message: err?.response?.data?.detail || t('ERROR_OCCURRED'),
        })
        setLoading(false)
      })
  }

  useEffect(() => {
    _updateStatus()
    const interval = setInterval(() => {
      _updateStatus()
    }, 30000) // Обновляем каждые 30 секунд
    return () => {
      clearInterval(interval)
    }
  }, [])

  if (loading) return <TopProgress loading={loading} />

  const isWorking = status?.is_working || status?.status === 'working' || status?.status === 'active' || false
  const lastRun = status?.last_run || status?.last_run_at || null

  return (
    <StatusSection>
      <StatusRow>
        <StatusLabel>{t('SERVICE_STATUS')}:</StatusLabel>
        <StatusValue>
          <StatusIndicator active={isWorking} />
          {isWorking ? t('WORKING') : t('NOT_WORKING')}
        </StatusValue>
      </StatusRow>

      {lastRun && (
        <StatusRow>
          <StatusLabel>{t('LAST_RUN')}:</StatusLabel>
          <StatusValue>{timeConverterMMDDYYHHMM(lastRun)}</StatusValue>
        </StatusRow>
      )}

      {status?.message && (
        <StatusRow>
          <StatusLabel>{t('MESSAGE')}:</StatusLabel>
          <StatusValue>{status.message}</StatusValue>
        </StatusRow>
      )}

      {status?.error && (
        <StatusRow>
          <StatusLabel>{t('ERROR')}:</StatusLabel>
          <StatusValue style={{ color: '#E85048' }}>{status.error}</StatusValue>
        </StatusRow>
      )}
    </StatusSection>
  )
}

export default StatusTab
